// extracted by mini-css-extract-plugin
export default {"inputBox":"InputCmp_inputBox__KzrO3","requiredAsterisk":"InputCmp_requiredAsterisk__EFm80"};